module.exports = __webpack_public_path__ + "c641eca57458eba874d13e9783aad177.pdf";